import { render, staticRenderFns } from "./ai-menu-config.vue?vue&type=template&id=99bd9b3c&scoped=true"
import script from "./ai-menu-config.vue?vue&type=script&lang=js"
export * from "./ai-menu-config.vue?vue&type=script&lang=js"
import style0 from "./ai-menu-config.vue?vue&type=style&index=0&id=99bd9b3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99bd9b3c",
  null
  
)

export default component.exports